/**
 * Production API host for App Hypwave / Link Management.
 *
 * In the browser on a real domain, we use the current origin (same-site `/api`)
 * so app.hypwave.com → https://app.hypwave.com/api (no CORS).
 *
 * Optional build-time override: REACT_APP_API_URL / REACT_APP_BACKEND_URL.
 */
export const PRODUCTION_API_ORIGIN = 'https://app.hypwave.com';

const LOCAL_API_ORIGIN = 'http://localhost:3001';

function isLocalHost(): boolean {
  if (typeof window === 'undefined') return process.env.NODE_ENV !== 'production';
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1';
}

function normalizeOrigin(raw: string): string {
  return raw.trim().replace(/\/$/, '');
}

function resolveOrigin(): string {
  const fromEnv =
    process.env.REACT_APP_BACKEND_URL?.trim() ||
    process.env.REACT_APP_API_URL?.trim()?.replace(/\/?api\/?$/i, '');

  if (isLocalHost() || process.env.NODE_ENV !== 'production') {
    if (fromEnv && (fromEnv.includes('localhost') || fromEnv.includes('127.0.0.1'))) {
      return normalizeOrigin(fromEnv);
    }
    return LOCAL_API_ORIGIN;
  }

  // Prefer same-origin in the browser so each domain hits its own /api proxy.
  if (typeof window !== 'undefined' && window.location?.origin) {
    const host = window.location.hostname;
    if (host && host !== 'localhost' && host !== '127.0.0.1') {
      return normalizeOrigin(window.location.origin);
    }
  }

  if (fromEnv) return normalizeOrigin(fromEnv);
  return normalizeOrigin(PRODUCTION_API_ORIGIN);
}

/** Axios / fetch base including `/api` — e.g. https://app.hypwave.com/api */
export function getApiBaseUrl(): string {
  return `${resolveOrigin()}/api`;
}

/** Backend origin without `/api` — for `/uploads/...` */
export function getBackendOrigin(): string {
  return resolveOrigin();
}
